import React, { memo, useState, useContext, useEffect, useRef } from "react";

import { Box, Divider } from "@mui/material";

import Tabla from "./Componentes/Tabla";
import ModalB from "../../../components/Extra/ModalB";
import BarraTablas from "../../../components/BarraTablas/BarraTablas";
import clienteAxios from "../../../config/axios";
import AlertaContext from "../../../Context/Alerta/AlertaContext";
import AuthContext from "../../../Context/Auth/AuthContext";
import Modal from "./Componentes/Modal";
import Especies from "../Especies/Especies";
import Alimentos from "../Alimentos/Alimentos";
import Sexo from "../Sexo/Sexo";
import Personas_Veterinaria from "../Personas_Veterinaria/Personas_Veterinaria";
import ModalTraido from "./Componentes/ModalTraido";
import ModalPropietario from "../Personas_Veterinaria/Componentes/Modal";
import io from "socket.io-client";
import { socketUrl } from "../../../config/const";
import { usePermiso } from "../../../hooks/usePermiso";
import { TabsRolEliminado } from "../../components/Tablas/TabsRolEliminado";
const Contabilidad = (props) => {
  const { tienePermiso } = usePermiso("Mascotas");

  const {
    documentoPropietario,
    settab,
    setarrayExportHijos,
    desdeOtroLugarPropietario,
    puedeExportar,
    itemRelacionadoPadre,
  } = props;
  const [openEspecies, setopenEspecies] = useState(false);
  const [openAlimentos, setopenAlimentos] = useState(false);
  const [openSexo, setopenSexo] = useState(false);
  const [openPropietario, setopenPropietario] = useState(false);
  // DATA DEL STATE

  const [rows, setrows] = useState(null);
  const columns = [
    {
      minWidth: 150,
      label: "Propietario",
      propiedad: "mascPerNombre",
      id: "mascPerNombre",
      tipo: "string",
      orden: 3,
      variante: "autocompleteDinamico",
      propiedadesMostrar: 2,
      campoData1: "perDocNumero",
      campoData2: "perNombre",
      getData: async (data) => {
        const res = await clienteAxios.get(
          `/proveedores/filtro/0?search=${data}&estado=CLIENTE`
        );
        return res;
      },
    },
    {
      minWidth: 50,
      label: "Medico T.",
      propiedad: "nombre_medico_tratante",
      id: "nombre_medico_tratante",
      tipo: "string",
      orden: 3,
      variante: "string",
    },
    {
      minWidth: 50,
      label: "#Carnet",
      propiedad: "mascId",
      id: "mascId",
      tipo: "string",
      orden: 2,
    },
    {
      minWidth: 50,
      label: "Micro Chip",
      propiedad: "mascMicroChip",
      id: "mascMicroChip",
      tipo: "string",
      orden: 2,
    },
    {
      minWidth: 50,
      label: "Caracter",
      propiedad: "mascCaracter",
      id: "mascCaracter",
      tipo: "string",
      orden: 2,
    },
    {
      minWidth: 150,
      label: "Mascota",
      propiedad: "mascNombre",
      id: "mascNombre",
      tipo: "string",
      orden: 3,
      variante: "autocompleteDinamico",
      propiedadesMostrar: 2,
      campoData1: "mascNombre",
      campoData2: "mascPerNombre",
      getData: async (data) => {
        const res = await clienteAxios.get(`/mascotas/filtro/0?search=${data}`);
        return res;
      },
    },
    {
      minWidth: 50,
      label: "Especie",
      propiedad: "mascEspecie",
      id: "mascEspecie",
      tipo: "string",
      orden: 3,
      variante: "autocompleteDataDefault",
      propiedadesMostrar: 1,
      campoData1: "espNombre",
      getData: async () => {
        const res = await clienteAxios.get(`/especies/filtro/0`);
        return res;
      },
    },
    {
      minWidth: 50,
      label: "Raza",
      propiedad: "mascRaza",
      id: "mascRaza",
      tipo: "string",
      orden: 3,
    },

    {
      minWidth: 50,
      label: "Sexo",
      propiedad: "mascSexo",
      id: "mascSexo",
      tipo: "string",
      orden: 3,
      variante: "autocompleteDataDefault",
      propiedadesMostrar: 1,
      campoData1: "sexNombre",
      getData: async () => {
        const res = await clienteAxios.get(`/sexo/filtro/0`);
        return res;
      },
    },
    {
      minWidth: 50,
      label: "Color",
      propiedad: "mascColor",
      id: "mascColor",
      tipo: "string",
      orden: 3,
    },

    {
      minWidth: 50,
      label: "Edad",
      propiedad: "mascEdad",
      id: "mascEdad",
      tipo: "numero",
      orden: 2,
    },
    {
      minWidth: 50,
      label: "F. Nacimiento",
      propiedad: "mascFechaNacimiento",
      id: "mascFechaNacimiento",
      tipo: "fecha",
      orden: 2,
    },
    {
      minWidth: 50,
      label: "Alimento",
      propiedad: "mascAlimento",
      id: "mascAlimento",
      tipo: "string",
      orden: 2,
    },
    {
      minWidth: 50,
      label: "Estado",
      propiedad: "mascEstado",
      id: "mascEstado",
      tipo: "string",
      orden: 3,
      variante: "autocompleteComun",
      data: ["Vivo", "Fallecido", "Extraviado"],
    },

    {
      minWidth: 50,
      label: "User",
      propiedad: "mascUser",
      id: "mascUser",
      tipo: "string",
      orden: 3,
    },
    {
      minWidth: 50,
      label: "Fec Upd.",
      propiedad: "mascFecUpd",
      id: "mascFecUpd",
      tipo: "string",
      orden: 3,
    },
  ];
  const defaultFullBuscador = () => {
    const json = {};
    columns.forEach((itemPropiedad) => {
      Object.entries({ itemPropiedad }).forEach((item) => {
        if (itemPropiedad.tipo === "string") {
          json[`${item[1].propiedad}`] = "";
        } else if (itemPropiedad.tipo === "numero") {
          json[`${item[1].propiedad}1`] = "";
          json[`${item[1].propiedad}2`] = "";
        } else if (itemPropiedad.tipo === "fecha") {
          json[`${item[1].propiedad}1`] = "";
          json[`${item[1].propiedad}2`] = "";
        }
      });
    });

    return json;
  };
  const [openPropietarioModal, setopenPropietarioModal] = useState(false);
  const [ObjectoActivoPropietario, setObjetoActivoPropietario] = useState({
    perISPContratos: [],
    perNombreComercial: "",
    perEmpresa: [],
    perPais: "",
    perProvincia: "",
    perCanton: "",
    perTipoProveedor: "BIENES",
    perTiempoCredito: "0",
    perDocTipo: "",
    perDocNumero: "",
    perPerfil: [],
    perNombre: "",
    perDireccion: "",
    perObligado: "NO",
    perCredito: "NO",
    perTelefono: "0",
    perCelular: ["+593"],
    perEstado: "ACTIVO",
    perObsevacion: "",
    perEmail: ["sin@sincorreo.com"],
    perOtros: ["ZZZ9999"],
    perNickname: "",
    perUser: "",
    perFecReg: "",
    perFoto: "",
    perUbicacion: {
      longitud: "",
      latitud: "",
    },
    perDocumento: "",
    perGenero: "M",
    perRecomendacion: "",
    perFecNacimiento: "",
    perEspecialidad: "",
    perTitulo: "",
    perSenescyt: "",
    perPersonal: "INTERNO",
  });
  const [ObjectoActivo, setObjetoActivo] = useState({
    mascHistorialPropietarios: [],
    mascNombre: "",
    mascTipoSangre: "",
    mascDonador: "NO",
    mascIdMedicoTratante: "",
    nombre_medico_tratante: "",
    mascEspecie: "",
    mascRaza: "",
    mascAlimento: "",
    mascTipoAlimento: "",
    mascSexo: "",
    mascPeso: "",
    mascColor: "",
    mascFechaNacimiento: "",
    mascEdad: "",
    mascFoto: "",
    mascEstado: "",
    mascEliminado: "",
    mascQuienElimina: "",
    mascMicroChip: "",
    mascCaracter: "",
    mascObservacion: "",
    mascPerId: "",
    mascPerNombre: "",
    mascPerTelefono: "",
    mascPerDocNumero: "",
    mascPerDireccion: "",
    mascPerCelular: "",
    mascPerEmail: "",
    mascContactoExtra: [
      // {
      //   nombre: "JC",
      //   celular: "59387654321",
      //   correo: "jc@gmail.com",
      // },
    ],
    mascUser: "",
    mascEmpresa: "",
    mascFecReg: "",
    mascFecModificacion: "",
    Todos: "",
  });
  const [pagination, setpagination] = useState(null);

  // FUNCIONES STATE
  const getDataState = async (
    cantidad,
    page,
    search,
    input,
    orden,
    datos,
    rucempresa,
    eliminadoEstadoNuevo = eliminadoEstado,
    rolEstadoNuevo = rolEstado
  ) => {
    try {
      const res = await clienteAxios.get(
        `/mascotas/?cantidad=${cantidad}&page=${page}&search=${
          search ? search : ""
        }&input=${input ? input : ""}&orden=${orden ? orden : ""}&datos=${
          datos ? datos : ""
        }&rucempresa=${rucempresa ? rucempresa : ""}&documento=${
          documentoPropietario ? documentoPropietario : ""
        }&allData=${tienePermiso(
          "allData",
          rolEstadoNuevo
        )}&rol=${rolEstadoNuevo}&eliminado=${eliminadoEstadoNuevo}`
      );
      return res;
    } catch (error) {
      console.log({ error });
    }
  };

  const obtenerState = async (
    cantidad = 10,
    page = 0,
    search,
    input,
    orden,
    datos,
    rucempresa,
    eliminadoEstadoNuevo,
    rolEstadoNuevo
  ) => {
    const res = await getDataState(
      cantidad,
      page,
      search,
      input,
      orden,
      datos,
      rucempresa,
      eliminadoEstadoNuevo,
      rolEstadoNuevo
    );
    setrows(res.data.data.results);
    setpagination(res.data.data.pagination);
  };
  const addRowsState = async (items) => {
    setrows([...rows, ...items]);
  };
  const remplazarRowsState = async (
    cantidad,
    page,
    search,
    input,
    orden,
    datos,
    rucempresa,
    eliminadoEstado,
    rolEstado
  ) => {
    const res = await getDataState(
      cantidad,
      page,
      search,
      input,
      orden,
      datos,
      rucempresa,
      eliminadoEstado,
      rolEstado
    );
    setrows(res.data.data.results);
    setpagination(res.data.data.pagination);
    // dispatch({
    //   type: OBTENER,
    //   payload: {
    //     results: res.data.data.results,
    //     pagination: res.data.data.pagination,
    //   },
    // });
  };
  const agregarState = async (item) => {
    try {
      setrows([item, ...rows]);

      setpagination({
        ...pagination,
        numRows: pagination.numRows + 1,
      });
    } catch (error) {}
  };

  const editarState = async (item) => {
    try {
      const resRows = rows.map((itemR) => {
        if (itemR.mascId === item.mascId) {
          return item;
        } else {
          return itemR;
        }
      });

      setrows(resRows);
    } catch (error) {}
  };

  const eliminarState = async (_id) => {
    try {
      const resRows = rows.filter((row) => {
        return row.mascId !== _id;
      });
      setrows(resRows);
      setpagination({
        ...pagination,
        numRows: pagination.numRows - 1,
      });
    } catch (error) {}
  };
  const eliminarSeleccionState = async (_ids) => {
    const resRows = rows.filter((row) => {
      return !_ids.some((item) => {
        return item === row.mascId;
      });
    });
    setpagination({
      ...pagination,
      numRows: pagination.numRows - _ids.length,
    });
    setrows(resRows);
  };

  const changeObjetoActivoState = (item) => {
    setObjetoActivo(item);
    // dispatch({
    //   type: CHANGE_ACTIVO,
    //   payload: item,
    // });
  };
  const changeObjetoActivoStatePropietario = (item) => {
    setObjetoActivoPropietario(item);
    // dispatch({
    //   type: CHANGE_ACTIVO,
    //   payload: item,
    // });
  };
  const rowsImportState = (rows) => {
    // dispatch({
    //   type: IMPORTAR_ROWS,
    //   payload: rows,
    // });
    setrows(rows);
  };
  // FIN FUNCIONES STATE
  // FIN DATA STATE

  // FUNCIONES SOCKET
  const [tabla] = useState("mascota");
  const [itemSocket, setitemSocket] = useState({
    tipo: "",
    item: {},
  });

  const socket = useRef();
  useEffect(() => {
    // Creates a WebSocket connection
    socket.current = io(socketUrl);
    socket.current.on("server:guardadoExitoso", (data) => {
      if (data.tabla !== tabla) {
        return;
      }

      setitemSocket({
        tipo: "agregar",
        item: data,
      });
    });
    socket.current.on("server:actualizadoExitoso", (data) => {
      if (data.tabla !== tabla) {
        return;
      }

      setitemSocket({
        tipo: "editar",
        item: data,
      });
    });
    socket.current.on("server:eliminadoExitoso", (data) => {
      if (data.tabla !== tabla) {
        return;
      }
      setitemSocket({
        tipo: "eliminar",
        item: data,
      });
    });
    socket.current.on("server:eliminadoExitosoSeleccionado", (data) => {
      if (data.tabla !== tabla) {
        return;
      }
      setitemSocket({
        tipo: "eliminarSeleccion",
        item: data,
      });
    });

    socket.current.on("server:error", (data) => {
      mostrarAlerta(
        data.msg ? data.msg : "Hubo un error",
        data.alert ? data.alert : "error"
      );
    });
    return () => {
      socket.current.disconnect();
    };
    // Destroys the socket reference
    // when the connection is closed
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    const { item, tipo } = itemSocket;

    if (tipo === "") {
      return;
    }
    if (!rows) {
      return;
    }
    if (usuario.rucempresa !== item.rucempresa) {
      return;
    }
    if (item.tabla !== tabla) {
      return;
    }
    const funcionAalerta = () => {
      if (item.msg === "") {
        return null;
      }
      if (!item.msg) {
        return null;
      }
      mostrarAlerta(item.msg, item.alert ? item.alert : "success");
    };

    if (tipo === "agregar") {
      agregarState(item);
    }
    if (tipo === "editar") {
      editarState(item);
    }
    if (tipo === "eliminar") {
      eliminarState(item.mascId);
    }
    if (tipo === "eliminarSeleccion") {
      eliminarSeleccionState(item.lista);
    }
    funcionAalerta();
    setitemSocket({ tipo: "", item: {} });
    // eslint-disable-next-line
  }, [itemSocket]);

  const [open, setopen] = useState(false);
  const [buscando, setbuscando] = useState(false);
  const [editar, seteditar] = useState(false);
  const [search, setsearch] = useState("");
  const [cargando, setcargando] = useState(false);
  const [input, setinput] = useState({
    id: "mascFecUpd",
    label: "ID",
    minWidth: 150,
    tipo: "string",

    propiedad: "mascFecUpd",
  });
  const [arrayExport, setarrayExport] = useState([]);
  const [campoExport] = useState("mascId");
  useEffect(() => {
    if (desdeOtroLugarPropietario) {
      settab("");
      setarrayExportHijos(arrayExport.map((item) => item[campoExport]));
    }
    // eslint-disable-next-line
  }, [arrayExport]);
  const { mostrarAlerta } = useContext(AlertaContext);
  const {
    usuario: { rucempresa },
    usuario,
  } = useContext(AuthContext);
  const [orden, setorden] = useState(false);
  const [openMB, setopenMB] = useState(false);
  const [fullBuscador, setfullBuscador] = useState({});

  //pagina actual
  const [page, setPage] = React.useState(0);
  //filas por pagina
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [eliminadoEstado, seteliminadoEstado] = useState(false);
  const [rolEstado, setrolEstado] = useState(usuario.rol[0]);
  //
  const handleChange = (e) => {
    setfullBuscador({ ...fullBuscador, [e.target.name]: e.target.value });
  };
  const funcionB = async () => {
    setcargando(true);
    await remplazarRowsState(
      rowsPerPage,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      rucempresa,
      eliminadoEstado,
      rolEstado
    );
    setPage(0);
    setbuscando(true);
    setopenMB(false);
    setcargando(false);
  };

  const handleSearch = async () => {
    setarrayExport([]);
    setcargando(true);
    await remplazarRowsState(
      rowsPerPage,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      rucempresa,
      eliminadoEstado,
      rolEstado
    );

    setPage(0);
    setcargando(false);
  };
  useEffect(() => {
    const fullBRes = defaultFullBuscador();

    setfullBuscador(fullBRes);
    // eslint-disable-next-line
  }, []);

  const funcionDefault = async (
    { eliminadoEstado, rolEstado } = { eliminadoEstado, rolEstado }
  ) => {
    setcargando(true);
    const fullBRes = defaultFullBuscador();
    setfullBuscador(fullBRes);
    await remplazarRowsState(
      rowsPerPage,
      0,
      "",
      input.id,
      orden,
      JSON.stringify(fullBRes),
      rucempresa,
      eliminadoEstado,
      rolEstado
    );

    setPage(0);
    setsearch("");
    setbuscando(false);
    setcargando(false);
    setopenMB(false);
  };

  return (
    <Box>
      <BarraTablas
        search={search}
        setsearch={setsearch}
        funcion={handleSearch}
        buscando={buscando}
        setbuscando={setbuscando}
        setopen={(boolean) => {
          if (desdeOtroLugarPropietario) {
            setObjetoActivo({
              ...ObjectoActivo,
              mascPerId: itemRelacionadoPadre.perId,
              mascPerNombre: itemRelacionadoPadre.perNombre,
              mascPerTelefono: itemRelacionadoPadre.perTelefono,
              mascPerDocNumero: itemRelacionadoPadre.perDocNumero,
              mascPerDireccion: itemRelacionadoPadre.perDireccion,
              mascPerCelular: itemRelacionadoPadre.perCelular,
              mascPerEmail: itemRelacionadoPadre.perEmail,
            });
          }
          setopen(boolean);
        }}
        open={open}
        openMB={openMB}
        setopenMB={setopenMB}
        LabelBuscador="Buscar Por: #Carnet, Nombre Mascota, Cédula, Nombre Propietario"
        funcionDefault={funcionDefault}
        subirArchivo={false}
        ocultarMigasDePan={desdeOtroLugarPropietario}
        ocultarOpciones={false}
      />
      <ModalPropietario
        estadoRequest={"CLIENTE"}
        editar={true}
        seteditar={() => {}}
        setopen={setopenPropietarioModal}
        open={openPropietarioModal}
        ObjectoActivo={ObjectoActivoPropietario}
        changeObjetoActivoState={changeObjetoActivoStatePropietario}
        socket={socket}
      />
      <ModalTraido
        open={openPropietario}
        setopen={setopenPropietario}
        titulo="Personas"
        Componente={Personas_Veterinaria}
      />
      <ModalTraido
        open={openEspecies}
        setopen={setopenEspecies}
        titulo="Especies"
        Componente={Especies}
      />
      <ModalTraido
        open={openAlimentos}
        setopen={setopenAlimentos}
        titulo="Alimentos"
        Componente={Alimentos}
      />
      <ModalTraido
        open={openSexo}
        setopen={setopenSexo}
        titulo="Sexo"
        Componente={Sexo}
      />
      <ModalB
        defaultFullBuscador={defaultFullBuscador}
        openMB={openMB}
        setopenMB={setopenMB}
        titulo={"Busqueda avanzada (Mascotas)"}
        fullBuscador={fullBuscador}
        setfullBuscador={setfullBuscador}
        arrayProps={[...columns]}
        handleChange={handleChange}
        funcionB={funcionB}
        buscando={buscando}
        funcionDefault={funcionDefault}
      />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems=" stretch"
        width="100%"
      >
        <TabsRolEliminado
          setarrayExport={setarrayExport}
          filtrarEliminar={async (nuevoEstadoEliminado) => {
            seteliminadoEstado(nuevoEstadoEliminado);
            await funcionDefault({
              eliminadoEstado: nuevoEstadoEliminado,
              rolEstado,
            });
          }}
          cargando={cargando}
          filtrarRol={async (nuevoEstadoRol) => {
            setrolEstado(nuevoEstadoRol);
            await funcionDefault({
              eliminadoEstado,
              rolEstado: nuevoEstadoRol,
            });
          }}
          eliminadoEstado={eliminadoEstado}
          rolEstado={rolEstado}
        />
      </Box>
      <Divider />
      <Tabla
        eliminadoEstado={eliminadoEstado}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        search={search}
        input={input}
        orden={orden}
        setinput={setinput}
        setorden={setorden}
        open={open}
        setopen={setopen}
        buscando={buscando}
        cargando={cargando}
        setcargando={setcargando}
        fullBuscador={fullBuscador}
        //  STATE
        rows={rows}
        columns={columns}
        ObjectoActivo={ObjectoActivo}
        pagination={pagination}
        // FUNCIONES STATE
        getDataState={getDataState}
        obtenerState={obtenerState}
        addRowsState={addRowsState}
        remplazarRowsState={remplazarRowsState}
        agregarState={agregarState}
        editarState={editarState}
        eliminarState={eliminarState}
        eliminarSeleccionState={eliminarSeleccionState}
        changeObjetoActivoState={changeObjetoActivoState}
        rowsImportState={rowsImportState}
        arrayExport={arrayExport}
        setarrayExport={setarrayExport}
        puedeExportar={puedeExportar}
        desdeOtroLugarPropietario={desdeOtroLugarPropietario}
        seteditar={seteditar}
        // PROPIETARIO
        changeObjetoActivoStatePropietario={changeObjetoActivoStatePropietario}
        setopenPropietarioModal={setopenPropietarioModal}
        socket={socket}
      />
      <Modal
        changeObjetoActivoStatePropietario={changeObjetoActivoStatePropietario}
        setopenPropietarioModal={setopenPropietarioModal}
        eliminadoEstado={eliminadoEstado}
        editar={editar}
        seteditar={seteditar}
        setopen={setopen}
        open={open}
        ObjectoActivo={ObjectoActivo}
        changeObjetoActivoState={changeObjetoActivoState}
        //OTRO LADO
        openEspecies={openEspecies}
        setopenEspecies={setopenEspecies}
        openAlimentos={openAlimentos}
        setopenAlimentos={setopenAlimentos}
        openSexo={openSexo}
        setopenSexo={setopenSexo}
        setopenPropietario={setopenPropietario}
        socket={socket}
      />
    </Box>
  );
};

export default memo(Contabilidad);
